require('./constat.scss');
import DemandeActions from '../../../../actions/demande.actions';
import MultiplexActions from '../../../../actions/multiplex.actions';
import TypeDefautActions from '../../../../actions/type-defaut.actions';

import { OUI_NON, TYPE_PROBLEME } from '../../../common/model';
import { STEPS } from '../../../../utils/routes.util';
import assign from 'lodash/assign';
import filter from 'lodash/filter';
import forEach from 'lodash/forEach';
import some from 'lodash/some';
import cloneDeep from 'lodash/cloneDeep';

export default class ConstatComponent {
  constructor() {
    this.controller = ConstatController;
    this.template = require('./constat.html');
  }
}

// @ngInject
class ConstatController {

  constructor($scope, $ngRedux) {

    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.OUI_NON = OUI_NON;
    this.TYPE_PROBLEME = TYPE_PROBLEME;
    // Valeurs par défaut
    this.data = {multiplex: [], typePerturbation: [], typeDefaut: []};
    this.multiplexCode = {};
  }

  $onInit() {
    // Demande de récupération de la demande avant connexion au state
    this.$ngRedux.dispatch(DemandeActions.loadDemande(STEPS.CONSTAT));
    this.$ngRedux.dispatch(MultiplexActions.loadData());
    this.$ngRedux.dispatch(TypeDefautActions.loadData());

    // Connexion au state récupérer les données modifiées
    const disconnect = this.$ngRedux.connect(
      state => {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          multiplexFailure: state.multiplex.failure,
          typeDefautFailre: state.typeDefaut.failure,
          fetching: state.demande.fetching || state.multiplex.fetching || state.typeDefaut.fetching,
          data: state.demande.data.constat ? state.demande.data.constat.asMutable({deep: true}) : this.data,
          multiplex: state.demande.data.accueilInterface2 ? state.demande.data.accueilInterface2.multiplex : state.multiplex.data,
          typeDefaut: state.typeDefaut.data

        };
      }
    )((selectedState) => {
        assign(this, selectedState);
        this.handleMultiplexLoaded();
      });
    // Déconnexion du state à la suppression du composant
    this.$scope.$on('$destroy', disconnect);
  }
  onEmetteurtntChange(emetteurtnt) {
    this.data.emetteurtnt = emetteurtnt;
  }

  onTypeDefautChange(typeDefaut) {
    this.data.typeDefaut = typeDefaut;
  }
  onTypePerturbationChange(typePerturbation) {
    this.data.typePerturbation = typePerturbation;
  }

  handleMultiplexLoaded() {
    if (this.fetching) {
      return;
    }
    if (!this.multiplex.length) {
      return;
    }
    this.data.multiplex = filter(this.data.multiplex, multiplex => some(this.multiplex, (m) => m.id === multiplex.id));
    forEach(this.data.multiplex, (multiplex) => {
      this.multiplexCode[multiplex.id] = true;
    });
  }
  onChangeSelected(multiplex) {
    if (this.multiplexCode[multiplex.id]) {
      // Sélection du multiplex
      this.data.multiplex.push(multiplex);
    } else {
      // Déselection du multiplex
      this.data.multiplex = filter(this.data.multiplex, (m) => m.id !== multiplex.id);
    }
  }
  prepareBeforeSend(data) {
    const res = cloneDeep(data);
    res.typeDefaut = this.typeDefaut;
    return res;
  }
  // Actions
  prevStep() {
    this.$ngRedux.dispatch(DemandeActions.updateConstat(this.data, true));
  }
  nextStep() {

    this.$ngRedux.dispatch(DemandeActions.updateConstat(this.prepareBeforeSend(this.data)));
  }
}



// WEBPACK FOOTER //
// ./src/modules/antenniste/components/constat/constat.component.js